import { toggleClasses } from "../../bladejs/toggle-classes";

document.addEventListener("DOMContentLoaded", () => {
	// Controls the opening and closing of gift guides disclaimer
	document
		.querySelectorAll(".guideDisclaimerToggle")
		?.forEach((guideDisclaimerToggle) => {
			guideDisclaimerToggle.addEventListener("click", () => {
				toggleClasses(document.querySelector(".guideDisclaimerWindow"), [
					"tw:hidden",
					"tw:flex",
				]);
			});
		});

	// Gift Guide Selectors
	const productCategory = document.querySelectorAll(".sidebarCategory");
	const entriesContainer = document.querySelectorAll(".giftGuideCategory");
	const categoryEntries = Array.from(entriesContainer).flatMap((container) =>
		Array.from(container.children),
	);
	const twSmallScreen = 640;

	if (window.innerWidth < twSmallScreen) {
		document
			.querySelectorAll(".sidebarCategory, .giftGuideCategory")
			.forEach((el) => {
				el.classList.toggle("tw:flex");
				el.classList.toggle("tw:hidden");
			});
		document
			.querySelectorAll(".expandToggle")
			.forEach((el) => (el.textContent = "+"));
	} else {
		productCategory?.[0]
			?.querySelector("img")
			.classList.add("favy-nav-guide-icon-rotate-open");
		entriesContainer?.[0]?.classList.remove("tw:hidden");
		entriesContainer?.[0]?.classList.add("favy-gift-guide-category-open");
		categoryEntries?.forEach((entry) => {
			entry.classList.remove("tw:hidden");
			entry.classList.add("favy-gift-guide-category-entry-show");
		});
	}

	const closeAll = () => {
		document
			.querySelectorAll(".favy-nav-guide-icon-rotate-open")
			.forEach((el) => el.classList.remove("favy-nav-guide-icon-rotate-open"));
		document
			.querySelectorAll(".favy-gift-guide-category-entry-show")
			.forEach((el) => {
				el.classList.remove("favy-gift-guide-category-entry-show");
				el.classList.add("tw:hidden");
			});
		document
			.querySelectorAll(".giftGuideCategory.favy-gift-guide-category-open")
			.forEach((el) => el.classList.remove("favy-gift-guide-category-open"));
	};

	productCategory?.forEach((category) => {
		category.addEventListener("click", () => {
			closeAll();
			category
				.querySelector("img")
				.classList.toggle("favy-nav-guide-icon-rotate-open");
			const nextCategory = category.nextElementSibling;
			nextCategory.classList.remove("tw:hidden");
			nextCategory.classList.toggle("favy-gift-guide-category-open");
			Array.from(nextCategory.children).forEach((child) => {
				child.classList.remove("tw:hidden");
				child.classList.add("favy-gift-guide-category-entry-show");
			});
		});
	});

	document.querySelectorAll(".guideNavigation")?.forEach((nav) => {
		nav.addEventListener("click", () => {
			closeAll();
			document
				.querySelectorAll(".sidebarCategory, .giftGuideCategory")
				.forEach((el) => {
					el.classList.toggle("tw:flex");
					el.classList.toggle("tw:hidden");
				});
			document.querySelectorAll(".expandToggle").forEach((el) => {
				el.textContent = document
					.querySelector(".sidebarCategory")
					.classList.contains("tw:flex")
					? "-"
					: "+";
			});
		});
	});
});
